/**
* Create a component for rectbox precentage.
*/
import React from 'react';

import './rectbox.scss'

class RectBoxPercentage extends React.Component {
	constructor(props) {
		super(props);
		this.getPercentage = this.getPercentage.bind(this);
	}

	getPercentage(value) {
		return ((value.indexOf('-1') >= 0 || value < 0) ? '--' : value);
	}

	render() {
		return (
			<div className="rectbox-percentage" style={{ background: this.props.style.color, borderRadius: this.props.style.borderRadius }}>
				<div>
					{this.getPercentage(this.props.count)}
					{
						this.props.showPercentage &&
						<span className="percentage-sign">
							%
						</span>
					}
				</div>
			</div>
		);
	}
}

export default RectBoxPercentage;
